import React from 'react';
import { Router } from 'react-router';
import { createBrowserHistory } from 'history';

class CustomRouter extends React.Component {
  constructor(props) {
    super(props);

    this.history = createBrowserHistory();
    if (document.location.href.includes('widget')) {
      this.history.oldPush = this.history.push;
      this.history.push = function push(path, state) {
        if (path.includes('widget')) {
          this.oldPush(path, state);
        } else {
          document.location.href = path;
        }
      };
      this.history.oldReplace = this.history.replace;
      this.history.replace = function replace(path, state) {
        if (path.includes('widget')) {
          this.oldReplace(path, state);
        } else {
          document.location.href = path;
        }
      };
    }
  }

  render() {
    const { children } = this.props;
    return <Router history={this.history}>{children}</Router>;
  }
}

export default CustomRouter;
